import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { COMMA, ENTER, SPACE } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import {
  Component,
  Input,
  OnInit,
  TemplateRef,
  Output,
  EventEmitter,
} from '@angular/core';
import {
  FormArray,
  FormControl,
  FormGroup,
  Validators,
  AbstractControl,
} from '@angular/forms';
import {
  AuctionService,
  EmailTemplateService,
  LoaderService,
} from '../../../services';
import constants from '../../../utility/constants';
import { ToastrService } from 'ngx-toastr';
import { ImageValidators } from '../../../core/validators/image-validators';
import { CommonDropdown } from '../../../models';
import { AppValidators } from '../../../core/validators/app-validators';
import { Router } from '@angular/router';
import { Observable, BehaviorSubject } from 'rxjs';
import messages from '../../../utility/messages';
import {  Subscription } from 'rxjs';

@Component({
  selector: 'app-add-auction-step3',
  templateUrl: './add-auction-step3.component.html',
  styleUrls: ['./add-auction-step3.component.css'],
})
export class AddAuctionStep3Component implements OnInit {
  @Input('isEditMode') editMode: boolean;
  @Input('auctionId') auctionId: number;
  @Input('auctionStatus') auctionStatus: number;
  @Output('goToStep') step: EventEmitter<number> = new EventEmitter();

  modalRef: BsModalRef;
  loading: boolean = false;
  fileProccessed: number;
  checkLoader: boolean;
  // null because we do not want any thing on loader
  checkLoader$ = new BehaviorSubject<any>(null);
  step3Form: FormGroup;
  fieldMaxLengthShorter = constants.common.validations.maxLength25;
  fieldMaxLength = constants.common.validations.maxLength50;
  fieldMaxLengthMedium = constants.common.validations.maxLength100;
  fieldMaxLength1000 = constants.common.validations.maxLength1000;
  fieldMaxLengthLong = constants.common.validations.maxLength500;
  premiumMaxLength = constants.common.validations.maxLength1500;
  fieldMaxLengthLonger = constants.common.validations.maxLength2500;
  keywordLength: number = constants.common.validations.maxLength100;
  fieldMaxLengthTenThousand = constants.common.validations.maxLength10000;
  isRegUrlAllowed: boolean;
  isCatalogUrlAllowed: boolean;
  // keyword chips setting
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA, SPACE];
  keywords: Array<string> = [];
  // upcoming auction list dropdown
  upcomingAuctionList: Array<CommonDropdown>;
  // template list dropdown
  prePostTemplateList: Array<CommonDropdown>;
  showForm: boolean = false;
  showView: boolean = false;
  // for ckeditor binding strings
  featuredItemsText: string = null;
  gBpText: string = null;
  ccBpText: string = null;

  // for bind the button name from buttons popup
  currentButtonControl: any;
  // aaray for tracking the new and old added or deleted custom buttons
  addDeleteButtonFile: Array<any> = [];
  // documents settings
  documentString: string;
  payDocumentString: string;

  documentFormat = constants.admin.uploadSetting.documentType;
  documentSize = constants.admin.uploadSetting.documentMaxSize;
  customButtonString: string;
  customButtons: Array<string>; // for popup
  // partner logo settings
  partnerLogoArray: File[] = [];
  logoFormat = constants.admin.uploadSetting.partnerLogoType;
  logoSize = constants.admin.uploadSetting.partnerLogoMaxSize;
  validComboDrag: any;
  lastInvalids: any;
  fileDropDisabled: any;
  baseDropValid: any;
  addEditPartnerLogo: Array<{ id: number; name: File | string }>;
  // current button control, need to bind with button's doc uploading process
  currentButtonFileUpload: any;
  showFeaturedItemsHeader: boolean = true;
  // to check characters limit
  isEditorCharLimitReached: boolean;

  submitted: boolean = false;

  showBPasEditor: boolean;

  isShowEmailTemplates: boolean = true;

  paymentInstructionEditorString: string = null;
  private subscriptions: Array<Subscription> = [];

  constructor(
    private modalService: BsModalService,
    private auctionService: AuctionService,
    private toastr: ToastrService,
    private templateService: EmailTemplateService,
    private router: Router,
    private loaderService: LoaderService
  ) {}

  ngOnInit(): void {
    this.fileProccessed = 0;
    this.initializeForm();
    this.getAuctionSpecificSaletype(this.auctionId);
    this.getUpcomingAuction();
    this.getPrePostTemplate();
    this.getPaymentInstText();
    this.getButtons();
    this.bindData();

    const loader = this.checkLoader$.subscribe((res: any) => {
      // false means no images left for processing
      if (res == false) {
        this.addAuctionStep3();
      }
    });
    this.subscriptions.push(loader);
  }

  initializeForm() {
    this.step3Form = new FormGroup({
      auctionId: new FormControl(this.auctionId),
      registrationLinkUrl: new FormControl(null),
      catalogLinkUrl: new FormControl(null),
      pageTitle: new FormControl(null, [
        AppValidators.noWhitespace,
        Validators.maxLength(this.fieldMaxLengthMedium),
      ]),
      metaDescription: new FormControl(null, [
        AppValidators.noWhitespace,
        Validators.maxLength(this.fieldMaxLengthLong),
      ]),
      keywords: new FormControl(null),
      relatedAuctionIds: new FormControl(null),
      preApprovalRegistrationEmailTemplateId: new FormControl(4, [
        Validators.required,
      ]),
      postApprovalRegistrationEmailTemplateId: new FormControl(4, [
        Validators.required,
      ]),
      emailNotes: new FormControl(null, [
        AppValidators.noWhitespace,
        Validators.maxLength(this.fieldMaxLength1000),
      ]),
      generalBuyerPremium: new FormControl(
        constants.admin.initialValues.generalBuyersPremium,
        [Validators.required, AppValidators.noWhitespace]
      ),
      creditCardBuyerPremium: new FormControl(
        constants.admin.initialValues.creditCardBuyersPremium,
        [AppValidators.noWhitespace]
      ),
      gBP: new FormControl(constants.admin.initialValues.generalBuyersPremium, [
        Validators.required,
        Validators.min(0),
        Validators.max(100),
        AppValidators.onlyNumeric,
      ]),
      ccBP: new FormControl(
        constants.admin.initialValues.creditCardBuyersPremium,
        [Validators.min(0), Validators.max(100), AppValidators.onlyNumeric]
      ),
      featuredItemHeader: new FormControl(null, [
        AppValidators.noWhitespace,
        Validators.maxLength(this.fieldMaxLength),
      ]),
      featuredItems: new FormControl(null),
      paymentInstructions: new FormControl(null, [
        Validators.required,
        AppValidators.noWhitespace,
      ]),
      documents: new FormArray([]),
      buttons: new FormArray([]),
      paymentDocuments: new FormArray([]),
    });
  }

  initializeButtonDoc() {
    let buttonLength = this.step3Form.value.buttons.length;
    let docLength = this.step3Form.value.documents.length;
    let payDocLength = this.step3Form.value.paymentDocuments.length;
    if (docLength <= 0) {
      this.documentString = messages.addAuction3.addDocument;
    } else {
      this.documentString = messages.addAuction3.addAnotherDocument;
    }
    if (payDocLength <= 0) {
      this.payDocumentString = messages.addAuction3.addDocument;
    } else {
      this.payDocumentString = messages.addAuction3.addAnotherDocument;
    }
    if (buttonLength <= 0) {
      this.customButtonString = messages.addAuction3.addNewButton;
    } else {
      this.customButtonString = messages.addAuction3.addAnotherButton;
    }
  }

  getAuctionSpecificSaletype(auctionId: number) {
    const saletypes = this.auctionService.getAuctionSaleType(auctionId).subscribe(
      (res) => {
        this.showView = true;
        this.checkRegUrlIsRequired(res.registrationFormat);
        this.checkCatalogUrlIsRequired(res.isCatalogUploadAllowed);
        this.isShowEmailTemplates =
          res.registrationFormat !=
          constants.common.saletypeRegistrationFormat.thirdPartyRegistration;
      },
      (err) => {
        this.showView = true;
      }
    );
    this.subscriptions.push(saletypes);
  }

  checkRegUrlIsRequired(registrationFormat: number) {
    if (
      registrationFormat ==
      constants.common.saletypeRegistrationFormat.thirdPartyRegistration
    ) {
      this.isRegUrlAllowed = true;
      let control = this.step3Form.controls.registrationLinkUrl;
      control.setValidators([
        AppValidators.noWhitespace,
        AppValidators.checkWebAddress,
      ]);
      control.updateValueAndValidity();
    } else {
      this.isRegUrlAllowed = false;
    }
  }

  checkCatalogUrlIsRequired(catalogUploadAllowed: boolean) {
    if (!catalogUploadAllowed) {
      this.isCatalogUrlAllowed = true;
      let control = this.step3Form.controls.catalogLinkUrl;
      control.setValidators([
        AppValidators.noWhitespace,
        AppValidators.checkWebAddress,
      ]);
      control.updateValueAndValidity();
    } else {
      this.isCatalogUrlAllowed = false;
    }
  }

  addKeyword(event: MatChipInputEvent) {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim()) {
      let keyword = value.trim();
      this.keywords.push(keyword);
      this.checkKeyWordLength();
    }
    if (input) {
      input.value = '';
    }
  }
  removeKeyword(key: string): void {
    const index = this.keywords.indexOf(key);
    if (index >= 0) {
      this.keywords.splice(index, 1);
      this.checkKeyWordLength();
    }
  }
  changeToKeywords(commaSepString: string): Array<string> {
    let keywordArray = commaSepString.split(',');
    keywordArray.forEach((i) => this.keywords.push(i));
    return keywordArray;
  }
  checkKeyWordLength() {
    if (this.keywords.length > this.keywordLength) {
      this.step3Form.controls.keywords.setErrors({
        invalidKeywordLength: {
          requiredLength: this.keywordLength,
        },
      });
    } else {
      this.step3Form.controls.keywords.setErrors(null);
    }
    this.step3Form.controls.keywords.markAsTouched();
  }

  getUpcomingAuction() {
    const uauctions = this.auctionService.getUpcomingAuctions(this.auctionId).subscribe((res) => {
      this.upcomingAuctionList = res;
    });
    this.subscriptions.push(uauctions);
  }
  getPrePostTemplate() {
    const templates = this.templateService.getEmailTemplateDropdown().subscribe((res) => {
      this.prePostTemplateList = res;
    });
    this.subscriptions.push(templates);
  }
  getPaymentInstText() {
   const pinstructions = this.auctionService.getPaymentInstruction().subscribe((res) => {
      if (!this.paymentInstructionEditorString) {
        this.paymentInstructionEditorString = res;
        this.step3Form.patchValue({
          paymentInstructions: res,
        });
      }
    });
    this.subscriptions.push(pinstructions);
  }
  getButtons() {
    const cbtns = this.auctionService
      .getCustomButtons()
      .subscribe((res) => (this.customButtons = res));
      this.subscriptions.push(cbtns);
  }

  editorContent(
    event: { data: string; limitReached: boolean },
    control: AbstractControl,
    isControlRequired = false
  ) {
    control.patchValue(event.data == null ? '' : event.data);
    control.markAsDirty();
    if (isControlRequired && (event.data === null || event.data === ''))
      control.setErrors({ required: true });
    else if (event.limitReached) control.setErrors({ invalid: true });
    else control.setErrors(null);
  }

  documents(paymentDoc: boolean = false): FormArray {
    if (paymentDoc) return this.step3Form.get('paymentDocuments') as FormArray;
    return this.step3Form.get('documents') as FormArray;
  }
  newDocument(paymentDoc: boolean = false): FormGroup {
    let assetType;
    paymentDoc
      ? (assetType = new FormControl(constants.admin.assetType.paymentDocument))
      : (assetType = new FormControl(constants.admin.assetType.document));

    return new FormGroup({
      auctionId: new FormControl(this.auctionId),
      assetType: assetType,
      fileId: new FormControl(0),
      fileTitle: new FormControl(null, [
        AppValidators.noWhitespace,
        Validators.required,
        Validators.maxLength(this.fieldMaxLengthShorter),
      ]),
      file: new FormControl(null, [
        Validators.required,
        ImageValidators.sizeCheck(this.documentSize),
        ImageValidators.pdfFormat(this.documentFormat),
      ]),
    });
  }
  addDocument(paymentDoc: boolean = false) {
    this.documents(paymentDoc).push(this.newDocument(paymentDoc));
    this.initializeButtonDoc();
  }
  attachDocument(doc: FormGroup, docFile: File) {
    let fileControl = doc.controls.file;
    doc.patchValue({
      file: docFile,
    });
    fileControl.markAsTouched();
    fileControl.updateValueAndValidity();
  }
  deleteDocument(index: number, doc?: FormGroup, paymentDoc: boolean = false) {
    if (doc.value.fileId > 0) {
      this.uploadSingleDocument(doc.value, doc.value.assetType, true);
    }
    this.documents(paymentDoc).removeAt(index);
  }
  eachDocumentControl(doc) {
    return doc.controls;
  }
  eachDocumentFileNameisString(doc) {
    let control: any = this.eachDocumentControl(doc).file.value;
    if (typeof control == 'string') {
      return true;
    }
    return false;
  }

  removeLogo(index: number) {
    this.partnerLogoArray.splice(index, 1);
  }
  removeOldImage(item) {
    this.uploadSingleDocument(
      {
        fileId: item.id,
        file: null,
      },
      constants.admin.assetType.partnerLogo,
      true
    );
  }

  buttons(): FormArray {
    return this.step3Form.get('buttons') as FormArray;
  }
  newButton(): FormGroup {
    return new FormGroup({
      id: new FormControl(0),
      label: new FormControl(null, [
        Validators.required,
        AppValidators.noWhitespace,
        Validators.maxLength(this.fieldMaxLength),
      ]),
      isUrl: new FormControl(true),
      url: new FormControl(null, [
        AppValidators.noWhitespace,
        AppValidators.checkWebAddress,
      ]),
      auctionFileName: new FormControl(null, [
        ImageValidators.sizeCheck(this.documentSize),
        ImageValidators.pdfFormat(this.documentFormat),
      ]),
      buttonName: new FormControl(null, [Validators.required]),
      isDeleted: new FormControl(false),
    });
  }
  addButton() {
    this.buttons().push(this.newButton());
    this.initializeButtonDoc();
  }
  attachButtonFile(btn: FormGroup, btnFile: File) {
    let btnFileControl = btn.controls.auctionFileName;
    this.currentButtonFileUpload = btn;
    btn.patchValue({
      auctionFileName: btnFile,
    });
    btnFileControl.markAsTouched();
    btnFileControl.updateValueAndValidity();
    if (btnFileControl.valid) {
      this.loaderService.showLoader(true);
      this.uploadSingleDocument(
        {
          fileId: 0,
          file: btnFileControl.value,
          fileTitle: btn.controls.label.value,
        },
        constants.admin.assetType.customButtonDocument
      );
    }
  }
  deleteButton(index: number, btn?: FormGroup) {
    if (btn.value.id > 0) {
      this.addDeleteButtonArray(btn);
    }
    this.buttons().removeAt(index);
  }
  eachButtonControl(btn) {
    return btn.controls;
  }
  addDeleteButtonArray(btn: FormGroup) {
    let btnData = btn.value;
    btnData.isDeleted = true;
    this.addDeleteButtonFile.push(btnData);
  }
  setButtonName(form) {
    this.currentButtonControl.patchValue({
      buttonName: form.value.customButton,
    });
    this.closeModal();
  }
  eachButtonFileNameisString(btn) {
    let control: any = this.eachButtonControl(btn).auctionFileName.value;
    if (typeof control == 'string') {
      return true;
    }
    return false;
  }
  changeButtonType(control) {
    let checkIsUrl = control.isUrl.value;
    let urlControl = control.url;
    let fileControl = control.auctionFileName;

    if (checkIsUrl) {
      urlControl.setValidators([
        Validators.required,
        AppValidators.noWhitespace,
        AppValidators.checkWebAddress,
      ]);
      fileControl.clearValidators();
    } else {
      fileControl.setValidators([
        Validators.required,
        ImageValidators.sizeCheck(this.documentSize),
        ImageValidators.pdfFormat(this.documentFormat),
      ]);
      urlControl.clearValidators();
    }
    fileControl.updateValueAndValidity();
    urlControl.updateValueAndValidity();
  }

  uploadDocumentOnServer() {
    let obj = this.documents().controls;
    for (let index = 0; index < obj.length; index++) {
      let docObj = obj[index];
      if (docObj.valid && typeof docObj.value.file != 'string')
        this.uploadSingleDocument(docObj.value, docObj.value.assetType);
    }
  }

  uploadPaymentDocumentOnServer() {
    let obj = this.documents(true).controls;
    for (let index = 0; index < obj.length; index++) {
      let docObj = obj[index];
      if (docObj.valid && typeof docObj.value.file != 'string')
        this.uploadSingleDocument(docObj.value, docObj.value.assetType);
    }
  }

  uploadPartnerLogoOnServer() {
    let formats = this.logoFormat.split(',');
    let obj =
      this.partnerLogoArray && this.partnerLogoArray?.length
        ? this.partnerLogoArray.filter((it) =>
            formats.includes(
              it.name.split('.')[it.name.split('.').length - 1].toLowerCase()
            )
          )
        : [];
    this.partnerLogoArray = obj;
    for (let index = 0; index < obj.length; index++) {
      let docObj = obj[index];
      this.uploadSingleDocument(
        { fileId: 0, file: docObj },
        constants.admin.assetType.partnerLogo
      );
    }
  }

  //////////////////////// constructing form for save
  constructForm() {
    let formData = this.step3Form.getRawValue();

    let changeButtonResponse = formData.buttons.map((obj) => {
      let button = null;
      if (obj.buttonName != '' || obj.buttonName != null) {
        button =
          obj.buttonName.split('/')[obj.buttonName.split('/').length - 1];
      }
      return {
        id: obj.id,
        label: obj.label,
        isUrl: obj.isUrl,
        url: obj.url,
        auctionFileName: obj.auctionFileName,
        buttonName: button,
        isDeleted: obj.isDeleted,
      };
    });
    let changeButton = changeButtonResponse.concat(this.addDeleteButtonFile);
    return {
      auctionId: this.auctionId,
      generalBuyerPremium: !this.showBPasEditor
        ? '' + formData.gBP
        : '' + formData.generalBuyerPremium,
      creditCardBuyerPremium: !this.showBPasEditor
        ? '' + formData.ccBP
        : '' + formData.creditCardBuyerPremium,
      catalogLinkUrl: formData.catalogLinkUrl,
      emailNotes: formData.emailNotes,
      featuredItemHeader: formData.featuredItemHeader,
      featuredItems: formData.featuredItems,
      keywords: this.keywords.length > 0 ? this.keywords.join(',') : null,
      metaDescription: formData.metaDescription,
      pageTitle: formData.pageTitle,
      paymentInstructions: formData.paymentInstructions,
      postApprovalRegistrationEmailTemplateId:
        formData.postApprovalRegistrationEmailTemplateId,
      preApprovalRegistrationEmailTemplateId:
        formData.preApprovalRegistrationEmailTemplateId,
      registrationLinkUrl: formData.registrationLinkUrl,
      relatedAuctionIds:
        formData.relatedAuctionIds != null
          ? formData.relatedAuctionIds.join(',')
          : null,
      buttons: changeButton,
    };
  }

  /////////////////////// final submission
  onSaveAndContinue() {
    this.submitted = true;
    if (this.step3Form.invalid) {
      return;
    }

    this.checkFileProcesses();

    this.uploadPartnerLogoOnServer();
    this.uploadDocumentOnServer();
    this.uploadPaymentDocumentOnServer();
  }

  addAuctionStep3() {
    this.loading = true;
    this.loaderService.showLoader(true);
    let model = this.constructForm();
    const step3 =  this.auctionService.addAuctionStep3(model).subscribe(
      (res) => {
        this.loading = false;
        this.loaderService.showLoader(false);
        this.toastr.success(
          this.editMode
            ? messages.addAuction3.updated
            : messages.addAuction3.saved,
          constants.common.toast.successTitle,
          constants.common.toast.config
        );
        this.goToStep(4);
      },
      (err) => {
        this.loading = false;
        this.loaderService.showLoader(false);
        this.toastr.error(
          err,
          constants.common.toast.errorTitle,
          constants.common.toast.config
        );
      }
    );
    this.subscriptions.push(step3);
  }

  checkFileProcesses() {
    let allDocuments = this.step3Form.value.documents as [];
    let uploadingDocs = allDocuments.filter(
      (obj: any) => typeof obj.file != 'string'
    );

    let allPaymentDocuments = this.step3Form.value.paymentDocuments as [];
    let uploadingPaymentDocs = allPaymentDocuments.filter(
      (obj: any) => typeof obj.file != 'string'
    );

    let allPartnerLogos = this.partnerLogoArray;
    let totalFiles =
      uploadingDocs.length +
      allPartnerLogos.length +
      uploadingPaymentDocs.length;

    if (totalFiles == 0) {
      this.addAuctionStep3();
      return false;
    }

    if (totalFiles > this.fileProccessed) {
      this.loaderService.showLoader(true);
      return true;
    }

    this.loaderService.showLoader(false);
    return false;
  }

  uploadSingleDocument(
    fileObj: any,
    assetType: number,
    isDelete: boolean = false
  ): Observable<string> {
    let returnedUrl: Observable<string>;
    let fileFormData = new FormData();
    fileFormData.append('AuctionId', '' + this.auctionId);
    fileFormData.append('AssetType', '' + assetType);
    fileFormData.append('FileId', '' + fileObj.fileId);
    if(fileObj.file === null){
      fileFormData.append('File', fileObj.file)
    }else{
      (typeof fileObj.file === 'string') ?
      fileFormData.append('File', fileObj.file) :
      fileFormData.append('File', fileObj.file,fileObj.file?.name);
    }
    fileFormData.append('FileTitle', fileObj.fileTitle);

    const imgrm = this.auctionService.imageAddRemove(fileFormData).subscribe(
      (response) => {
        if (
          !isDelete &&
          assetType != constants.admin.assetType.customButtonDocument
        ) {
          this.fileProccessed++;
          this.checkLoader = this.checkFileProcesses();
          this.checkLoader$.next(this.checkFileProcesses());
        }
        if (isDelete) {
          this.toastr.success(
            messages.addAuction3.fileRemoved,
            constants.common.toast.successTitle,
            constants.common.toast.config
          );
        }
        if (assetType == constants.admin.assetType.customButtonDocument) {
          this.loaderService.showLoader(false);
          this.currentButtonFileUpload.patchValue({
            auctionFileName: response,
          });
          this.currentButtonFileUpload.markAsTouched();
          this.currentButtonFileUpload.updateValueAndValidity();

          this.toastr.success(
            messages.addAuction3.fileUpload,
            constants.common.toast.successTitle,
            constants.common.toast.config
          );
        }
        if (assetType == constants.admin.assetType.partnerLogo) {
          this.addEditPartnerLogo = response.partnerLogos;
        }
      },
      (err) => {
        if (!isDelete) {
          this.fileProccessed++;
          this.checkLoader$.next(this.checkFileProcesses());
          this.checkLoader = this.checkFileProcesses();
        }
        this.toastr.error(
          err,
          constants.common.toast.errorTitle,
          constants.common.toast.config
        );
      }
    );
    this.subscriptions.push(imgrm);

    return returnedUrl;
  }

  ////////////////////////////// Bind data
  bindData() {
    this.loaderService.showLoader(true);
    const aucstep3 = this.auctionService.getAuctionStep3(this.auctionId).subscribe(
      (res: any) => {
        this.loaderService.showLoader(false);
        this.attachDataToForm(res);
        this.showForm = true;
      },
      () => {
        this.loaderService.showLoader(false);
        this.showForm = true;
        this.onCancel();
      }
    );
    this.subscriptions.push(aucstep3);
  }

  //////////////////////////// attach to form in edit mode
  attachDataToForm(data: any) {
    if (data.saleType) {
      this.showFeaturedItemsHeader =
        data.saleType.isEditFeatureItemHeaderAllowed;
      this.showBPasEditor = data.saleType.isPremiumEditorRequired;
    }

    this.step3Form.patchValue({
      auctionId: data.id,
      registrationLinkUrl: data.registrationLinkUrl,
      catalogLinkUrl: data.catalogLinkUrl,
      pageTitle: data.pageTitle,
      metaDescription: data.metaDescription,
      keywords:
        data.keywords != null ? this.changeToKeywords(data.keywords) : null,
      relatedAuctionIds:
        data.relatedAuctionIds != null
          ? data.relatedAuctionIds.split(',').map((obj) => parseInt(obj))
          : null,
      preApprovalRegistrationEmailTemplateId:
        data.preApprovalRegistrationEmailTemplateId,
      postApprovalRegistrationEmailTemplateId:
        data.postApprovalRegistrationEmailTemplateId,
      emailNotes: data.emailNotes,
      featuredItemHeader: data.featuredItemHeader,
      featuredItems: data.featuredItems,
    });

    this.featuredItemsText = data.featuredItems;
    this.paymentInstructionEditorString = data.paymentInstructions
      ? data.paymentInstructions
      : this.paymentInstructionEditorString;
    if (data.paymentInstructions != null)
      this.step3Form.patchValue({
        paymentInstructions: data.paymentInstructions,
      });

    if (data.generalBuyersPremium) {
      if (data.saleType.isPremiumEditorRequired) {
        this.gBpText = this.auctionId ? data.generalBuyersPremium : '';
        this.step3Form.patchValue({
          generalBuyerPremium: this.auctionId
            ? data.generalBuyersPremium
            : null,
        });
      } else {
        this.step3Form.patchValue({
          gBP: data.generalBuyersPremium,
        });
      }
    }

    if (data.creditCardBuyersPremium) {
      if (data.saleType.isPremiumEditorRequired) {
        this.ccBpText = this.auctionId ? data.creditCardBuyersPremium : '';
        this.step3Form.patchValue({
          creditCardBuyerPremium: this.auctionId
            ? data.creditCardBuyersPremium
            : null,
        });
      } else {
        this.step3Form.patchValue({
          ccBP: data.creditCardBuyersPremium,
        });
      }
    } else {
      this.step3Form.patchValue({
        ccBP: data.creditCardBuyersPremium ?? this.step3Form.value.ccBP,
        creditCardBuyerPremium: data.creditCardBuyersPremium ?? this.step3Form.value.ccBP,
      });
    }

    if (data?.documents?.length > 0) {
      data.documents.forEach((obj, i) => {
        var document: FormGroup = this.newDocument();
        this.documents().push(document);
        this.documents().controls[i].patchValue({
          fileId: obj.id,
          fileTitle: obj.title,
          file: obj.name,
        });
      });
    }

    if (data?.paymentDocuments?.length > 0) {
      data.paymentDocuments.forEach((obj, i) => {
        var document: FormGroup = this.newDocument(true);
        this.documents(true).push(document);
        this.documents(true).controls[i].patchValue({
          fileId: obj.id,
          fileTitle: obj.title,
          file: obj.name,
        });
      });
    }

    if (data.buttons.length > 0) {
      data.buttons.forEach((obj, i) => {
        var button: FormGroup = this.newButton();
        this.buttons().push(button);
        this.buttons().controls[i].patchValue({
          id: obj.id,
          label: obj.label,
          isUrl: obj.isUrl,
          url: obj.url,
          auctionFileName: obj.auctionFileName,
          buttonName: obj.buttonName,
          isDeleted: obj.isDeleted,
        });
      });
    }

    this.addEditPartnerLogo = data.partnerLogos;

    if (data.preApprovalRegistrationEmailTemplateId == null) {
      if (this.prePostTemplateList) {
        let preTemplateArray = this.prePostTemplateList.filter(
          (x) => x.value == 13
        );
        this.step3Form
          .get('preApprovalRegistrationEmailTemplateId')
          .patchValue(preTemplateArray[0].value);
      }
    }

    if (data.postApprovalRegistrationEmailTemplateId == null) {
      if (this.prePostTemplateList) {
        let postTemplateArray = this.prePostTemplateList.filter(
          (x) => x.value == 15
        );
        this.step3Form
          .get('postApprovalRegistrationEmailTemplateId')
          .patchValue(postTemplateArray[0].value);
      }
    }

    this.initializeButtonDoc();
  }

  //////////////////////////////////// popups
  openModalImageButtonSelect(template: TemplateRef<any>, currentButton) {
    this.currentButtonControl = currentButton;

    this.modalRef = this.modalService.show(
      template,
      Object.assign(
        {},
        {
          class:
            'custom-popup select-image-modal modal-dialog modal-dialog-centered',
        }
      )
    );
  }

  closeModal() {
    this.currentButtonControl = null;
    if (this.modalRef) this.modalRef.hide();
  }
  onCancel() {
    if (this.auctionStatus == 1) {
      this.router.navigate(['/admin/dashboard/auction'], {
        queryParams: { type: 'live' },
      });
    } else if (this.auctionStatus == 2) {
      this.router.navigate(['/admin/dashboard/auction'], {
        queryParams: { type: 'upcoming' },
      });
    } else if (this.auctionStatus == 4) {
      this.router.navigate(['/admin/dashboard/auction'], {
        queryParams: { type: 'recent' },
      });
    } else {
      this.router.navigate(['/admin/dashboard/auction'], {
        queryParams: { type: 'pending' },
      });
    }
  }
  goToStep(step: number = 2) {
    this.step.emit(step);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }
  
  SyncPartnerLogoImages() {
    this.loaderService.showLoader(true);
    const plogo = this.auctionService.SyncPartnerLogoImages(this.auctionId).subscribe(
      () => {
        this.toastr.success(
          'Partnet Logo Images Upload Successfully.',
          constants.common.toast.successTitle,
          constants.common.toast.config
        );
        this.loaderService.showLoader(false);
      },
      (err) => {
        this.toastr.error(
          err,
          constants.common.toast.errorTitle,
          constants.common.toast.config
        );
        this.loaderService.showLoader(false);
      }
    );
    this.subscriptions.push(plogo);
  }
}
